import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 1.5H6C4.89543 1.5 4 2.39543 4 3.5V14.5C4 15.6046 4.89543 16.5 6 16.5H12C13.1046 16.5 14 15.6046 14 14.5V3.5C14 2.39543 13.1046 1.5 12 1.5Z",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 13.5H14",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgPhone);
export default ForwardRef;
